import getSymbolFromCurrency from 'currency-symbol-map';
import numeral from 'numeral';

/** From redux state:
        isAuthorised: state.auth.isAuthorised,
        ccy: state.site.ccy,
        fxrates: state.site.fxrates,
*/

export const convertToCurrencySimple = (amount, itemCCY, fxrates = [], selectedCCY) => {
    amount = parseFloat(amount);
    if (selectedCCY !== itemCCY) {
        const selectedFXRate = fxrates.find(fx => fx.currency === selectedCCY);
        const origFXRate = fxrates.find(fx => fx.currency === itemCCY);
        if(origFXRate){
            amount = amount / origFXRate.ExRate * selectedFXRate.ExRate;
        }
    }
    return parseFloat(amount.toFixed(2)); // round to nearest decimal place to 2 fixed decimal places
}

export const convertToCurrency = (amount, isParcel, fxrates = [], selectedCCY) => {
    amount = parseFloat(amount);

    const selectedFXRate = fxrates.find(fx => fx.currency === selectedCCY);

    if (isParcel) {
        // Parcels are in GBP (ppc)
        // if selectedCCY is GBP don't convert otherwise do conversion
        if (selectedCCY !== 'GBP') {
            // convert directly from parcel GBP base to selected fxrate (the fxrate base is always GBP)
            amount *= selectedFXRate.ExRate;
        }
    } else {
        // Singles are in USD
        // if selectedCCY is USD don't convert otherwise do conversion
        if (selectedCCY !== 'USD') {
            // first, convert to GBP (by dividing to USD) and then convert to selected fxrate (the fxrate base is always GBP)
            amount = convertToCurrencySimple(amount, 'USD', fxrates, selectedCCY);
        }
    }

    return parseFloat(amount.toFixed(2)); // round to nearest decimal place to 2 fixed decimal places
}

/* export const getPriceProps = (row, fxrates = [], ccy, selectedUnit = 'weight', selectedWeight=1) => {
    const isParcel = row.StkCatType === 'Multiple Items' ? true : false;

    row.WebSpecial = row.WebSpecial && parseFloat(row.WebSpecial) || 0;

    const d = {
        ...row,
        ppcOrig: row.ppc,
        priceOrig: row.price,
        price:  row.WebSpecial || row.price || row.ExWebTotal,
        ppc:    row.WebSpecial || row.ppc   || row.ExWebTotal,
    }

    let ppc;
    if (isParcel) {
        ppc = d.ppcOrig ? `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(d.ppcOrig, true, fxrates, ccy))).format('0,0.00')}` : false;
        ppc =             `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(d.ppc,     true, fxrates, ccy))).format('0,0.00')}`;
        ppc =             `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(d.price,   true, fxrates, ccy))).format('0,0.00')}`;
    } else {
        ppc = d.ppcOrig ? `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(d.priceOrig, false, fxrates, ccy)) / parseFloat(d.STWeight)).format('0,0.00')}` : false;
        ppc =             `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(d.price,     false, fxrates, ccy)) / parseFloat(d.STWeight)).format('0,0.00')}`;
        ppc =             `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(d.ppcOrig,   false, fxrates, ccy))).format('0,0.00')}`;
    }


    let price;
    if (!isParcel) {
        price = d.price ? `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(d.price, false, fxrates, ccy))).format('0,0.00')}` : false;
        price =           `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(d.priceOrig, false, fxrates, ccy))).format('0,0.00')}`;
    } else {
        price = selectedUnit === 'weight' ? `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(d.ppc, true, fxrates, ccy)) * selectedWeight).format('0,0.00')}` : 0;
        price =                             `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(d.price, true, fxrates, ccy))).format('0,0.00')}`;
    }

    let priceSpecial;
    if(d.WebSpecial){
        if(isParcel){
            priceSpecial = `${ getSymbolFromCurrency(ccy) } ${ numeral(Math.round(convertToCurrency(d.WebSpecial, true, fxrates, ccy))).format('0,0.00') } `;
        }else{
            priceSpecial = `${ getSymbolFromCurrency(ccy) } ${ numeral(Math.round(convertToCurrency(d.price, false, fxrates, ccy))).format('0,0.00') } `;
        }
    }

    let rapBelow;
    if (!isParcel) {
        rapBelow = d.RAP ? d.RAP + '%' : false;
    }

    return {
        ppc,
        rapBelow,
        price,
        priceSpecial,
    }
} */